<template>
    <div class="search-box">
        <base-title :path="`-1`"></base-title>
        <div class="search-sec">
            <base-input ref="inputRef" v-model="search_name" :placeholder="`输入玩家平台昵称进行搜索`" class="input-box"></base-input>
            <base-button :name="`搜索`" class="btn-search" @click="search_user" :wd="`1.8rem`" :ht="`.8rem`" :fz="`.26rem`"></base-button>
        </div>
        <div class="error">{{err}}</div>
    </div>
</template>
<script>
import { baseUrls } from '@/utils/baseUrlConfig'
const base_url = baseUrls.user_url

export default {
    name: 'search',
    data() {
        return {
            search_name: '',
            err: '',
        }
    },
    mounted() {
        setTimeout(() => {
            this.$refs.inputRef.focusInput()
        }, 500)
    },
    created() {},
    methods: {
        changeCode(val) {
            this.$nextTick(() => {
                if (val.length > 6) {
                    this.search_name = val.slice(0, 10)
                }
            })
        },

        check_name() {
            this.err = ''
            this.search_name = this.search_name.trim()
            if (this.search_name == '') {
                this.err = '用户昵称不能为空'
                return false
            }

            var flag = false
            $.ajax({
                url: base_url + '/GetNameExist?user_name=' + this.search_name,
                async: false,
                success: (res) => {
                    if (res.code != 0) {
                        flag = true
                        this.err = ''
                    } else {
                        this.err = '*未查找到该玩家，请核对平台昵称'
                    }
                },
            })
            return flag
        },
        // 搜索用户
        search_user() {
            if (!this.check_name()) {
                return false
            }
            this.$http.getUserPubByName(this.search_name, this.$storage.getToken()).then((res) => {
                if (res.result == 0) {
                    let userid = res.user_id;
                    this.$router.replace({ path: '/gamescore', query: { 
                        userid: userid } 
                    })
                }
            })
        },
    },
}
</script>
<style lang="scss" scoped>
.search-box {
    width: 100%;
    .search-sec {
        width: 100%;
        height: 1.1rem;
        position: relative;

        .input-box {
            width: 90%;
            padding-left: 0.5rem;
        }

        .btn-search {
            position: absolute;
            top: 50%;
            right: 8%;
            transform: translateY(-50%);
        }
    }

    .error {
        width: 100%;
        height: 0.36rem;
        line-height: 0.36rem;
        text-align: left;
        padding-left: 1rem;
        margin: 0 auto;
        margin-top: 0.12rem;
        color: #ff0000;
        font-size: 0.22rem;
    }
}
</style>




// WEBPACK FOOTER //
// src/view/gamescore/search.vue